import React from 'react'
import {
  Typography,
  Grid,
  Fab,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import DeleteIcon from '@material-ui/icons/Delete'

const REVOKE_URL_DELAY = 60000

const DocumentosListLocal = ({
  documentosLocais = [],
  onChangeDocumentosLocais,
  cannotUpdate,
  onClickNew
}) => {
  const handleOpen = documento => {
    const url = URL.createObjectURL(documento.file)
    window.open(url)
    setTimeout(() => URL.revokeObjectURL(url), REVOKE_URL_DELAY)
  }

  const handleRemove = documento => {
    onChangeDocumentosLocais(
      documentosLocais.filter(d => d.id !== documento.id)
    )
  }

  const renderList = list => {
    return list.length ? (
      <Grid item xs={12}>
        <List>
          {list.map(item => (
            <ListItem key={item.id}>
              <ListItemText
                primary={item.descricao}
                secondary={item.fileName}
              />
              <ListItemSecondaryAction>
                <IconButton
                  title="Abrir"
                  variant="contained"
                  onClick={() => handleOpen(item)}
                >
                  <OpenInNewIcon />
                </IconButton>
                <IconButton
                  title="Remover"
                  aria-label="Remover"
                  disabled={cannotUpdate}
                  onClick={() => handleRemove(item)}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Grid>
    ) : (
      <Grid item xs={12} sm={2}>
        <Typography variant="body1" gutterBottom>
          Nenhum Documento
        </Typography>
      </Grid>
    )
  }

  return (
    <Grid container alignItems="center" justifyContent="center" spacing={3}>
      <Grid item xs={12} sm={11}>
        <Typography variant="h6" gutterBottom>
          Lista de Documentos
        </Typography>
        <Typography variant="caption" color="textSecondary">
          Os documentos serão anexados ao enviar a solicitação.
        </Typography>
      </Grid>
      <Grid item xs={12} sm={1}>
        <Grid container direction="row" justifyContent="flex-end">
          <Fab
            aria-label="Adicionar"
            color="primary"
            disabled={cannotUpdate}
            onClick={onClickNew}
            size="small"
          >
            <AddIcon size={24} color="inherit" />
          </Fab>
        </Grid>
      </Grid>
      {renderList(documentosLocais)}
    </Grid>
  )
}
export default React.memo(DocumentosListLocal)
